import { api } from './api';

export interface Sucursal {
  id: number;
  tenantId: number;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  timezone: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface SucursalCreate {
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  timezone?: string;
  tenantId?: number;
}

export interface SucursalUpdate {
  name?: string;
  address?: string;
  phone?: string;
  email?: string;
  timezone?: string;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const sucursalService = {
  getAll: async (page = 1, limit = 10, search?: string, tenantId?: number): Promise<PaginatedResponse<Sucursal>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    if (tenantId) params.append('tenantId', tenantId.toString());
    
    const response = await api.get<PaginatedResponse<Sucursal>>(`/sucursales?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { sucursal: Sucursal } }> => {
    const response = await api.get<{ data: { sucursal: Sucursal } }>(`/sucursales/${id}`);
    return response.data;
  },

  create: async (data: SucursalCreate): Promise<{ data: { sucursal: Sucursal } }> => {
    const response = await api.post<{ data: { sucursal: Sucursal } }>('/sucursales', data);
    return response.data;
  },

  update: async (id: number, data: SucursalUpdate): Promise<{ data: { sucursal: Sucursal } }> => {
    const response = await api.put<{ data: { sucursal: Sucursal } }>(`/sucursales/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/sucursales/${id}`);
  }
};

